import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processOAuthSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      // Extract session_id from URL hash
      const hash = location.hash || window.location.hash;
      const params = new URLSearchParams(hash.replace('#', ''));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        console.error('No session_id found in URL');
        navigate('/login', { replace: true });
        return;
      }

      try {
        const user = await processOAuthSession(sessionId);
        // Clear the hash and navigate to dashboard with user data
        window.history.replaceState(null, '', '/dashboard');
        navigate('/dashboard', { replace: true, state: { user } });
      } catch (error) {
        console.error('OAuth processing failed:', error);
        navigate('/login', { 
          replace: true, 
          state: { error: error.message || 'OAuth login failed. Please try again or register first.' }
        });
      }
    };

    processSession();
  }, [location, navigate, processOAuthSession]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="text-center animate-fade-in">
        <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
